import {
  coerceNonNegativeInt,
  formatMonthDayLabel,
  formatOutcomeExecutionTooltipLabel,
} from './schedulerExecutionDailyChart';

/**
 * @typedef {Object} SchedulerScheduleStatusDailyDocLike
 * @property {string} [date] YYYY-MM-DD
 * @property {Object} [metrics]
 * @property {Object} [metrics.totals]
 * @property {unknown} [metrics.totals.activeCount]
 * @property {unknown} [metrics.totals.pausedCount]
 * @property {unknown} [metrics.totals.errorSuppressedCount]
 */

/**
 * Rows for Recharts ascending by calendar date (oldest first).
 *
 * @param {readonly SchedulerScheduleStatusDailyDocLike[]} firestoreDailyDocs
 * @returns {Array<{ dateKey: string, dateLabelShort: string, active: number, paused: number, errorSuppressed: number }>}
 */
export function buildSchedulerScheduleStatusDailyChartRowsAsc(firestoreDailyDocs) {
  const sortedAsc = [...firestoreDailyDocs].sort((documentA, documentB) => {
    const left = documentA.date ?? '';
    const right = documentB.date ?? '';
    return left.localeCompare(right);
  });
  return sortedAsc.map(function mapDailyDocument(dailyDoc) {
    const dateKey = typeof dailyDoc.date === 'string' ? dailyDoc.date : '';
    const totals = dailyDoc.metrics && typeof dailyDoc.metrics === 'object' ? dailyDoc.metrics.totals : {};
    const totalsRecord = totals && typeof totals === 'object' ? totals : {};
    return {
      dateKey,
      dateLabelShort: formatMonthDayLabel(dateKey),
      active: coerceNonNegativeInt(totalsRecord.activeCount),
      paused: coerceNonNegativeInt(totalsRecord.pausedCount),
      errorSuppressed: coerceNonNegativeInt(totalsRecord.errorSuppressedCount),
    };
  });
}

export { formatOutcomeExecutionTooltipLabel as formatScheduleStatusTooltipLabel };
